export default {
  flowName: null,
  flowState: null,
  flowCompanyIcon: null,
  flowTransitions: [],
  flowViewContent: [],
  flowViewOptions: {}
}
